import { PayDashboardTabs } from '@melio/ap-activities';
import { PaymentSchedulingPreference } from '@melio/platform-provider';

import { extendDefaultConfig } from '@/configByPartner/partnerConfig.utils';
import capOneLogo from '@/images/capone/capOneAvatarLogo.svg';
import { fiservLinks } from '@/links';

export const fiservUsBankConfig = extendDefaultConfig({
  default: {
    settings: {
      fundingSourcePolicy: {
        'bank-account': {
          fundingSourceGroup: 'bank-account',
          read: true,
          write: false,
        },
        credit: {
          fundingSourceGroup: 'credit',
          read: true,
          write: false,
        },
        debit: {
          fundingSourceGroup: 'debit',
          read: false,
          write: false,
        },
      },
      trustedPartners: ['Mastercard', 'Quickbooks', 'Visa'],
      supportEmail: 'support@melio.com',
      eoyCheck: {
        enabled: true,
        promoteFastCheck: true,
        link: '',
      },
      helpCenterUrl: '',
      isUnilateralDeliveryMethodSupported: false,
      isEmbeddedExperience: true,
      isPaymentApprovalLimitEnabled: true,
      isLineItemsEnabled: true,
      newBillExperience: {
        isRecurringEnabled: false,
      },
      newPayExperience: {
        isEnabled: true,
        tabsOrder: [
          PayDashboardTabs.Bills,
          PayDashboardTabs.Vendors,
          PayDashboardTabs.Approvals,
          PayDashboardTabs.Payments,
          PayDashboardTabs.Financing,
        ],
      },
      vendor: {
        collectedDetails: 'extended',
        vendorSelect: {
          createVendor: {
            showVendorDetailsForm: true,
          },
        },
        createVendor: {
          shouldSwitchToExtendedFormOnApiErrors: true,
          hasSkipDeliveryMethodButton: false,
          canAddVendorWithTheSameName: true,
          companyNameFormatRegexp: /^[ a-zA-Z0-9!"#$%&'()*+,\-'./\\:;<=>?@]+$/,
          companyNameMaxLength: 32,
        },
      },
      isMultiColoredAvatarsEnabled: false,
      payment: {
        scheduling: {
          scheduleBy: PaymentSchedulingPreference.ByDeliveryDate,
          hideScheduleDateIndication: true,
        },
        memoToVendor: {
          maxLength: 34,
          deliveryMethodBlackList: [
            'bank-account',
            'domestic-wire-account',
            'virtual-account',
            'international-account',
            'virtual-card',
          ],
        },
      },
      syncProgressIndicationEnabled: true,
      showCheckMarkIconForManagedVendor: false,
    },
    services: {
      forethoughtApiKey: '74ba8f52-1c1e-4b60-8b1e-bc74bcdd4a0d',
      zendeskKey: 'f7a6bedc-a1d0-49ef-855c-8297879a42d1',
      zendeskWorkflow: 'U.S. Bank',
    },
    tutorialVideo: '',
    zendesk: {
      headerColor: '#C3C4C2',
      resultListsColor: '#C3C4C2',
      themeColor: '#C3C4C2',
      logo: capOneLogo,
      title: 'Support',
    },
    links: fiservLinks,
  },
  prod: {
    services: {
      tabapay: {
        card: {
          url: 'https://sso.tabapay.com/SSOMelioUsBank.html',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
        credit: {
          url: 'https://sso.tabapay.com/SSOMelioUsBank.html?cards=visa,mastercard',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
        debit: {
          url: 'https://sso.tabapay.com/SSOMelioUsBank.html',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
      },
    },
    links: {
      failedToCollectSupport:
        'https://paybillsbymelio.zendesk.com/hc/en-us/articles/5339224613020-Resolving-unsuccessful-payments-in-Pay-Bills',
    },
  },
  dev: {
    services: {
      tabapay: {
        card: {
          url: 'https://sso.sandbox.tabapay.com:8443/SSOMelioUsBank.html',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
        credit: {
          url: 'https://sso.sandbox.tabapay.com:8443/SSOMelioUsBank.html?cards=visa,mastercard',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
        debit: {
          url: 'https://sso.sandbox.tabapay.com:8443/SSOMelioUsBank.html',
          iframeHeight: [430, 380],
          iframeWidth: '100%',
        },
      },
    },
    links: {
      failedToCollectSupport:
        'https://paybillsbymelio.zendesk.com/hc/en-us/articles/5339224613020-Resolving-unsuccessful-payments-in-Pay-Bills',
    },
  },
});
